import { Routes, Route, Navigate } from 'react-router-dom';
import RouterList from './RouterList';
import { setStorage, authLocalStorage, localGetStorage } from '@/lib/storage';
import { Fragment } from 'react';
import { LOCAL_SESSION } from '@/lib/common/name-space';
import { toast } from 'react-toastify';
// import { useWeb3 } from '@/hooks/use-web3';
import Layout from '@/layouts';

type routerProps = {
  path: string;
};
export default function Router({ path }: routerProps) {
  // '/' 두 개일 경우
  const length = path.split('/').length - 1;
  // 삼항?

  if (length > 2) {
    const temp = path.split('/');
    path = `/${temp[1]}/:path/:type`;
  } else if (length > 1) {
    const temp = path.split('/');
    path = `/${temp[1]}/:path`;
  }
  const list = RouterList();
  const routeList = list.filter((item) => path === item.url);
  if (routeList.length === 0) {
    return <></>;
    // TODO 완료 후 삭제
    // return <Navigate to="/signIn" />;
  }
  const route = routeList[0];

  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          {route.private === true ? (
            <>
              <Route path={route.url} element={<PrivateRoute element={route.element} url={route.url} />} />
            </>
          ) : (
            <Route path={route.url} element={route.element} />
          )}
        </Route>
      </Routes>
    </>
  );
}

type PrivateProps = {
  element: JSX.Element;
  url: string;
};
const PrivateRoute = ({ element, url }: PrivateProps) => {
  // const { web3authCall } = useWeb3();
  const re = localGetStorage(LOCAL_SESSION);
  if (!re) {
    return <Navigate to="/signIn" />;
  } else {
    const now = new Date();
    if (now.getTime() > re.sessionTime) {
      // 항목이 만료되었으면, 로컬 스토리지에서 제거하고 null 반환
      toast.error('세션 종료되었습니다.');
      localStorage.removeItem(LOCAL_SESSION);
      // (async () => {
      //   await web3authCall?.logout();
      // })();
      return <Navigate to="/signIn" />;
    }
  }
  // TODO 로그인 하고 난 후 redux로 저장시키고 redux에서 없으면 localGetStorage로 가져오자 그리고 redux로 저장시키자
  // const re = authLocalStorage().auth;
  // TODO 로그인 할 때 세션 시간 추가, 시간이 현재 시간보다 길 경우 예외처리(세션 만료면 종료)
  // if (!re) {
  //   return <Navigate to="/signIn" />;
  // }

  // const payload = {
  //   key: 'url',
  //   value: { url },
  // };
  // setStorage(payload);
  return <>{element}</>;
};
